// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__w4e3I","content":"styles_content__3brbk","row":"styles_row__3mrQC","footer":"styles_footer__1wPUL","phraseLength":"styles_phraseLength__1VE9J"};